export default __webpack_public_path__ + "static/media/notification-active.53ebfd4b.svg";